export default "__VITE_ASSET__CsioZOND__"